import { ProjectApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { useEffect, useState } from 'react';
import { OrganizationProjectsCount } from '../../../commonTypes/project.types';
import { useTranslation } from '../../useTranslation';

const useHttpGetProjectsCountOnMount = (from: string, to: string) => {
    const { t } = useTranslation('newNotifications');
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const [data, setData] = useState<OrganizationProjectsCount>({ countProjects: 0, createdAtCount: 0 });
    const toastHandler = useContainer(ToastStateHandler);
    const [isReady, setReady] = useState(false);

    useEffect(() => {
        const { exec, abort } = projectApi.getOrganizationProjectsCount({
            query: { from, to },
            onSuccess: res => setData(res.body),
            onError: () => toastHandler.push('warn', t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setReady(true),
        });
        exec();
        return abort;
    }, [projectApi]);

    return { data, isReady };
};

export default useHttpGetProjectsCountOnMount;
